
import React, { useState } from "react";
import { Beaker } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Reagent } from "@/types/reagent.types";

interface ReagentImageSectionProps {
  reagent: Reagent;
}

const ReagentImageSection: React.FC<ReagentImageSectionProps> = ({ reagent }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  
  // Check if the image URL is valid
  const hasValidImage = (reagent.imageUrl || reagent.image_url) && 
    typeof (reagent.imageUrl || reagent.image_url) === 'string' && 
    (reagent.imageUrl || reagent.image_url || "").trim() !== '' &&
    !imageError;

  return (
    <div className="aspect-video relative overflow-hidden bg-gray-100">
      {hasValidImage ? (
        <>
          {imageLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-reagent-blue"></div>
            </div>
          )}
          <img
            src={reagent.imageUrl || reagent.image_url}
            alt={reagent.name}
            className="object-cover w-full h-full"
            onLoad={() => setImageLoading(false)}
            onError={(e) => {
              console.error("Failed to load image:", reagent.imageUrl || reagent.image_url);
              setImageError(true);
              setImageLoading(false);
            }}
          />
        </>
      ) : (
        <div className="flex items-center justify-center h-full bg-reagent-light-blue">
          <Beaker className="h-24 w-24 text-reagent-blue opacity-50" />
        </div>
      )}
      <Badge className="absolute top-4 right-4 text-sm bg-reagent-blue">
        {(reagent.categories && reagent.categories.name) || reagent.category || "Uncategorized"}
      </Badge>
    </div>
  );
};

export default ReagentImageSection;
